// import Alpine from '../../vendor/livewire/livewire/dist/livewire.esm';

Alpine.store('images', {
    items: [],

    set(images) {
        this.items = images;
    },

    push(images) {
        return this.items.push(...images);
    },

    unshift(images) {
        return this.items.unshift(...images);
    },

    all() {
        return this.items;
    },
});
